module.exports = __webpack_public_path__ + "img/strategist.ea82bdfd.png";